import * as GS from 'styles/globalStyles';

const SectionTitle = ({ text, padding }) => (
  <GS.Container padding={padding}>
    <GS.Text fontBold>{text}</GS.Text>
  </GS.Container>
);

export default SectionTitle;
